export default [
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "institution",
    name: "Institution",
    component: () => import("../form/admin/Institution.vue"),
    meta: { title: "KHRDC-Admin", requiresAuth: true, isAdmin: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "duty",
    name: "Duty",
    component: () => import("../form/admin/Duty.vue"),
    meta: { itle: "KHRDC-Admin", requiresAuth: true, isAdmin: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "userManagement",
    name: "UserManagement",
    component: () => import("../form/admin/UserManagement.vue"),
    meta: { title: "KHRDC-Admin", requiresAuth: true, isAdmin: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "studyManagement",
    name: "StudyManagement",
    component: () => import("../form/admin/Study.vue"),
    meta: { title: "KHRDC-Admin", requiresAuth: true, isAdmin: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "studyRelUser",
    name: "StudyRelUser",
    component: () => import("../form/admin/StudyRelUser.vue"),
    meta: { title: "KHRDC-Admin", requiresAuth: true, isAdmin: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "researchGroup",
    name: "ResearchGroup",
    component: () => import("../form/admin/ResearchGroup.vue"),
    meta: { title: "KHRDC-Admin", requiresAuth: true, isAdmin: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "pathologyDx",
    name: "PathologyDx",
    component: () => import("../form/admin/PathologyDx.vue"),
    meta: { title: "KHRDC-Admin", requiresAuth: true, isAdmin: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "pathologyStain",
    name: "PathologyStain",
    component: () => import("../form/admin/PathologyStain.vue"),
    meta: { title: "KHRDC-Admin", requiresAuth: true, isAdmin: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "specimen",
    name: "Specimen",
    component: () => import("../form/admin/Specimen.vue"),
    meta: { title: "KHRDC-Admin", requiresAuth: true, isAdmin: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "test",
    name: "Test",
    component: () => import("../form/admin/Test.vue"),
    meta: { title: "KHRDC-Admin", requiresAuth: true, isAdmin: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "testSpecimenRef",
    name: "TestSpecimenRef",
    component: () => import("../form/admin/TestSpecimenRef.vue"),
    meta: { title: "KHRDC-Admin", requiresAuth: true, isAdmin: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "regimenType",
    name: "RegimenType",
    component: () => import("../form/admin/RegimenType.vue"),
    meta: { title: "KHRDC-Admin", requiresAuth: true, isAdmin: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "visitTab",
    name: "VisitTab",
    component: () => import("../form/admin/VisitTab.vue"),
    meta: { title: "KHRDC-Admin", requiresAuth: true, isAdmin: true },
  },
  {
    path: "bannerManagement",
    name: "BannerManagement",
    component: () => import("../form/admin/HomepageManagement.vue"),
    meta: { title: "KHRDC-Admin", requiresAuth: true, isAdmin: true },
  },
];
